import moment from 'moment';
import Constants from '../../utils/constants';
import BaseUserService from '../BaseUserService';
import DateUtils from '../../utils/DateUtils';

const path = 'timehero/userReportedDay/day';
export default class DayViewService extends BaseUserService {
    constructor() {
        super(path);
        this.path = path;
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            selectedDay: moment(criteria.selectedDay).format(Constants.DATE_JSON_FORMAT)
        });
    }

    list(query) {
        let path = `${this.domain}/${this.path}/list-ac`;
        if (query) {
            path += `?query=${query}`;
        }
        return this.fetch(path, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }
    normalizeTime(element) {
        const formattedUserTime = moment(element.userTime).format('HH:mm:ss');
        const formattedTimeFrom = moment(element.timeFrom).format('HH:mm:ss');
        const formattedTimeTo = moment(element.timeTo).format('HH:mm:ss');
        const formattedCreativeTime = !element.creativeTime || element.creativeTime === 0 ? '00:00:00' : moment(element.creativeTime).format('HH:mm:ss')

        element.userTime = element.userTime && DateUtils.isValidDate(element.userTime) ? formattedUserTime : null
        element.timeFrom = element.timeFrom && DateUtils.isValidDate(element.timeFrom) ? formattedTimeFrom : null
        element.timeTo = element.timeTo && DateUtils.isValidDate(element.timeTo) ? formattedTimeTo : null
        element.creativeTime = element.creativeTime && DateUtils.isValidDate(element.creativeTime) ? formattedCreativeTime : null;
    }

    keepOnlyId(obj) {
        return {
            id: obj.id
        };
    }

    normalizeElement(element, day) {
        this.normalizeTime(element.event);
        element.event.selectedDay = moment(day).format(Constants.DATE_JSON_FORMAT);
        element.project = this.keepOnlyId(element.project);
        element.activity = this.keepOnlyId(element.activity);
        return element
    }

    add(element, day) {
        const e = this.normalizeElement(this.cloneElement(element), day);
        return this.fetch(`${this.domain}/${this.path}/add`, {
            method: 'POST',
            body: JSON.stringify(e),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element, day) {
        const e = this.normalizeElement(this.cloneElement(element), day);
        return this.fetch(`${this.domain}/${this.path}`, {
            method: 'PUT',
            body: JSON.stringify(e)
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    delete(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    
    deleteRow(eventIds) {
        return this.fetch(`${this.domain}/${this.path}?events=${eventIds}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    approve(userDayId) {
        return this.fetch(`${this.domain}/${this.path}/approve?userDayId=${userDayId}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    open(userDayId) {
        return this.fetch(`${this.domain}/${this.path}/open?userDayId=${userDayId}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    reject(userDayId, rejectReason){
        return this.fetch(`${this.domain}/${this.path}/reject?userDayId=${userDayId}&rejectReason=${rejectReason}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}